import React, { useState } from "react";
import { Button, Pagination, Space, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/lib/table";
import { PaginationProps } from "antd/lib/pagination";
import { CONSTANT } from "../../../../config/Constant";
import {
  // EditOutlined,
  RedoOutlined,
  CloseCircleOutlined,
  MailOutlined,
  EyeOutlined,
} from "@ant-design/icons";
// import { checkPrivileges } from '../../../../config/Global';
import UpdateRequest from "./UpdateRequest";
// import moment from 'moment';
import moment from "moment-timezone";
import CancelRequest from "../components/CancelRequest";
import ReturnRequest from "./ReturnRequest";
import { camelCaseString } from "../../../../config/Global";
import UpdateEmailModal from "./UpdateEmailModal";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { getReport } from "../../../../store/SendMessageSlice";
import ViewReport from "./ViewReport";

interface DataType {
  key: string;
  index: string;
  id: string | any;
  request_retry_date: string;
  user_id: string;
  request_id: string;
  to_provider: string;
  number: string;
  identification_value: string;
  trx_no: string;
  from_provider: string;
  step1_action_name: string;
  step1_ack_code: string;
  step2_action_name: string;
  step2_ack_code: string;
  step3_action_name: string;
  step3_ack_code: string;
  step3_ack_code_date: string;
  step3_request_date_ISR: string;
  process_status: string;
  return_response: any | null;
  email: string;
  error_additional_details: string;
  created_date: string;
}

export const convertDateToIsrael = async (dateTime) => {
  const utcMoment = moment.utc(dateTime, "YYYY-MM-DDTHH:mm:ss");
  const israelMoment = utcMoment.tz("Asia/Jerusalem");
  const israelTime = israelMoment.tz("Asia/Jerusalem"); //.format('YYYY-MM-DDTHH:mm:ss')
  return israelTime;
};

const ListTable: React.FC<any> = (props) => {
  const {
    listData,
    setListData,
    totalData,
    tableloading,
    setTableLoading,
    paginationData,
    setPaginationData,
    getList,
    savePayload,
  } = props;
  const dispatch: AppDispatch = useDispatch();

  const [openUpdateModal, setOpenUpdateModal] = useState<boolean>(false);
  const [openUpdateData, setOpenUpdateData] = useState<any>();
  const [vewReport, setViewReport] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [openCancelModal, setOpenCancelModal] = useState<boolean>(false);
  const [openCancelData, setOpenCancelData] = useState<any>();

  const [openReturnModal, setOpenReturnModal] = useState<boolean>(false);
  const [openReturnData, setOpenReturnData] = useState<any>();

  const [openUpdateEmailModal, setOpenUpdateEmailModal] =
    useState<boolean>(false);
  const [updateEmailData, setUpdateEmailData] = useState<any>();

  const openViewDrawer = (data: any) => {
    const payload = {
      request_id: data.request_id,
    };
    dispatch(getReport(payload))
      .then((res: any) => {
        setReportData(res?.data);
        setViewReport(true);
      })
      .catch((e: any) => {
        console.warn(e);
        setViewReport(false);
      });
  };
  const closeViewDrawer = () => {
    setViewReport(false);
    setReportData(null);
  };
  // const userDetails = localStorage.getItem('userDetails');
  // const userRoles = userDetails && JSON.parse(userDetails)?.roles;

  const data: DataType[] = listData?.map((item, index) => ({
    key: index?.toString(),
    id: item?.id ?? index + 1,
    index: item?.index,
    request_retry_date: item?.request_retry_date,
    user_id: item?.user_id,
    request_id: item?.request_id,
    to_provider: item?.to_provider,
    // network_type: item?.network_type,
    number_type: item?.number_type,
    number: item?.number,
    from_number: item?.from_number,
    to_number: item?.to_number,
    identification_value: item?.identification_value,
    identification_value2nd: item?.identification_value2nd,
    identification_value3rd: item?.identification_value3rd,
    trx_no: item?.trx_no,
    from_provider: item?.from_provider,
    step1_action_name: item?.step1_action_name,
    step1_ack_code: item?.step1_ack_code,

    step2_action_name: item?.step2_action_name,
    step2_ack_code: item?.step2_ack_code,

    step3_action_name: item?.step3_action_name,
    step3_ack_code: item?.step3_ack_code,

    process_status: item?.process_status,
    return_response: item?.return_response,
    email: item?.email,
    error_additional_details: item?.error_additional_details,
    created_date: item?.created_date,
  }));

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "index",
      key: "index",
      width: 80,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.id.toString().localeCompare(b.id),
    },
    {
      title: "Request ID",
      dataIndex: "request_id",
      key: "request_id",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.request_id || "").localeCompare(b.request_id || ""),
      render: (_, record) => {
        return record?.request_id ? record?.request_id : CONSTANT.NO_DATA_FOUND;
      },
      fixed: "left",
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        (a?.created_date || "").localeCompare(b?.created_date || ""),
      render: (_, record) => {
        return record?.created_date
          ? record?.created_date
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Provider",
      children: [
        {
          title: "From",
          dataIndex: "from_provider",
          key: "from_provider",
          width: 180,

          sortDirections: ["descend", "ascend"],
          sorter: (a, b) =>
            (a.from_provider || "").localeCompare(b.from_provider || ""),
          render: (_, record) => {
            return record?.from_provider
              ? record?.from_provider
              : CONSTANT.NO_DATA_FOUND;
          },
        },
        {
          title: "To",
          dataIndex: "to_provider",
          key: "to_provider",
          width: 180,

          sortDirections: ["descend", "ascend"],
          sorter: (a, b) =>
            (a.to_provider || "").localeCompare(b.to_provider || ""),
          render: (_, record) => {
            return record?.to_provider
              ? record?.to_provider
              : CONSTANT.NO_DATA_FOUND;
          },
        },
      ],
    },

    {
      title: "Number",
      dataIndex: "number",
      key: "number",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.number || "").localeCompare(b.number || ""),
      render: (_, record) => {
        return record?.number ? record?.number : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
      render: (_, record) => {
        return record?.email ? record?.email : CONSTANT.NO_DATA_FOUND;
      },
    },

    {
      title: "Identification Value",
      dataIndex: "identification_value",
      key: "identification_value",
      width: 180,
      //
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        (a.identification_value || "").localeCompare(
          b.identification_value || ""
        ),
      render: (_, record) => {
        return record?.identification_value
          ? record?.identification_value
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Step-1",
      children: [
        {
          title: "Action Name",
          dataIndex: "step1_action_name",
          key: "step1_action_name",
          width: 180,

          sortDirections: ["descend", "ascend"],
          sorter: (a, b) =>
            (a.step1_action_name || "").localeCompare(
              b.step1_action_name || ""
            ),
          render: (_, record) => {
            return record?.step1_action_name
              ? camelCaseString(record?.step1_action_name)
              : CONSTANT.NO_DATA_FOUND;
          },
        },
        {
          title: "ACK CODE",
          dataIndex: "step1_ack_code",
          key: "step1_ack_code",
          width: 180,
          sortDirections: ["descend", "ascend"],
          sorter: (a, b) =>
            (a.step1_ack_code || "").localeCompare(b.step1_ack_code || ""),
          render: (_, record) => {
            return record?.step1_ack_code
              ? record?.step1_ack_code
              : CONSTANT.NO_DATA_FOUND;
          },
        },
      ],
    },
    // {
    //   title: "Step-2",
    //   children: [
    //     {
    //       title: "Action Name",
    //       dataIndex: "step2_action_name",
    //       key: "step2_action_name",
    //       width: 180,

    //       sortDirections: ["descend", "ascend"],
    //       sorter: (a, b) =>
    //         (a.step2_action_name || "").localeCompare(
    //           b.step2_action_name || ""
    //         ),
    //       render: (_, record) => {
    //         return record?.step2_action_name
    //           ? camelCaseString(record?.step2_action_name)
    //           : CONSTANT.NO_DATA_FOUND;
    //       },
    //     },
    //     {
    //       title: "ACK CODE",
    //       dataIndex: "step2_ack_code",
    //       key: "step2_ack_code",
    //       width: 180,
    //       sortDirections: ["descend", "ascend"],
    //       sorter: (a, b) =>
    //         (a.step2_ack_code || "").localeCompare(b.step2_ack_code || ""),
    //       render: (_, record) => {
    //         return record?.step2_ack_code
    //           ? record?.step2_ack_code
    //           : CONSTANT.NO_DATA_FOUND;
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: "Step-3",
    //   children: [
    //     {
    //       title: "Action Name",
    //       dataIndex: "step3_action_name",
    //       key: "step3_action_name",
    //       width: 180,

    //       sortDirections: ["descend", "ascend"],
    //       sorter: (a, b) =>
    //         (a.step3_action_name || "").localeCompare(
    //           b.step3_action_name || ""
    //         ),
    //       render: (_, record) => {
    //         return record?.step3_action_name
    //           ? camelCaseString(record?.step3_action_name)
    //           : CONSTANT.NO_DATA_FOUND;
    //       },
    //     },
    //     {
    //       title: "ACK CODE",
    //       dataIndex: "step3_ack_code",
    //       key: "step3_ack_code",
    //       width: 180,
    //       sortDirections: ["descend", "ascend"],
    //       sorter: (a, b) =>
    //         (a.step3_ack_code || "").localeCompare(b.step3_ack_code || ""),
    //       render: (_, record) => {
    //         return record?.step3_ack_code
    //           ? record?.step3_ack_code
    //           : CONSTANT.NO_DATA_FOUND;
    //       },
    //     },
    //   ],
    // },

    {
      title: "Process Status",
      dataIndex: "process_status",
      key: "process_status",
      width: 150,
      fixed: "right",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        (a.process_status || "").localeCompare(b.process_status || ""),
      render: (_, record) => {
        return record?.process_status
          ? record?.process_status
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Additional Details",
      dataIndex: "error_additional_details",
      key: "error_additional_details",
      width: 150,
      fixed: "right",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        (a.error_additional_details || "").localeCompare(
          b.error_additional_details || ""
        ),
      render: (_, record) => {
        return record?.error_additional_details
          ? record?.error_additional_details
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Action",
      key: "action",
      width: 250,
      fixed: "right",
      // hidden: !checkPrivileges(userRoles, 'admin'),
      render: (_, record, index) => {
        const isDisabled =
          record?.process_status === "Complete" ||
          record?.process_status === "Success" ||
          record?.process_status === "Failed" ||
          record?.process_status === "Canceled";

        const isReturnDisabled = record?.from_provider && record?.to_provider;

        return (
          <Space size="middle" wrap>
            <Tooltip title={"View Report"}>
              <Button
                type="default"
                icon={<EyeOutlined />}
                className="EditBtn iconBtn"
                onClick={() => openViewDrawer(record)}
                disabled={!record?.request_id}
              />
            </Tooltip>
            {/* <Tooltip
              title={
                isDisabled
                  ? "Can't Update it. This request is already closed."
                  : "Update Request"
              }
            >
              <Button
                onClick={() => {
                  handleUpdateRequest(record);
                }}
                icon={<EditOutlined />}
                type="default"
                className="iconBtn"
                disabled={isDisabled ? true : false}
              />
            </Tooltip> */}
            <Tooltip
              title={
                isDisabled
                  ? "Can't Update it. This request is already closed."
                  : "Update Email"
              }
            >
              <Button
                onClick={() => {
                  handleUpdateEmail(record);
                }}
                icon={<MailOutlined />}
                type="default"
                className="iconBtn"
                disabled={isDisabled ? true : false}
              />
            </Tooltip>
            <Tooltip
              title={
                isDisabled
                  ? "Can't cancel it. This request is already closed."
                  : "Cancel Request"
              }
            >
              <Button
                onClick={() => {
                  handleCancelRequest(record);
                }}
                icon={<CloseCircleOutlined />}
                type="default"
                className="cancelBtn iconBtn"
                disabled={isDisabled ? true : false}
              />
            </Tooltip>

            {record?.return_response ? (
              <Tooltip title={"Return Request Status"}>
                <Button
                  onClick={() => {
                    handleReturnRequest(record);
                  }}
                  icon={<RedoOutlined />}
                  type="default"
                  className="EditBtn iconBtn"
                />
              </Tooltip>
            ) : (
              <Tooltip
                title={
                  isDisabled
                    ? "Can't make return request. This process is already closed."
                    : "Return Request"
                }
              >
                <Button
                  onClick={() => {
                    handleReturnRequest(record);
                  }}
                  icon={<RedoOutlined />}
                  type="default"
                  className="cancelBtn iconBtn"
                  disabled={!isReturnDisabled ? true : false}
                />
              </Tooltip>
            )}
          </Space>
        );
      },
    },
  ];

  const handleUpdateRequest = (record: any) => {
    setOpenUpdateModal(!openUpdateModal);
    setOpenUpdateData(record);
  };

  const handleCancelRequest = (record: any) => {
    setOpenCancelModal(!openCancelModal);
    setOpenCancelData(record);
  };

  const handleCancelRequestClose = (record: any) => {
    setOpenCancelModal(false);
    setOpenCancelData({});
  };

  const handleReturnRequest = (record: any) => {
    setOpenReturnModal(!openReturnModal);
    setOpenReturnData(record);
  };

  const handleUpdateEmail = (record: any) => {
    setOpenUpdateEmailModal(true);
    setUpdateEmailData(record);
  };

  const closeUpdateEmail = () => {
    setOpenUpdateEmailModal(false);
    setUpdateEmailData(null);
  };

  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    page_size
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          loading={tableloading}
          bordered
          size="small"
          scroll={{ x: 1000, y: 400 }}
          rowHoverable={true}
          tableLayout={"fixed"}
        />
      </div>
      <div className="text-center mt-20 mb-30">
        <Pagination
          defaultCurrent={1}
          current={paginationData?.current}
          total={totalData ?? 0}
          onChange={handleChange}
          responsive={true}
          pageSize={paginationData?.page_size ?? 10}
          showSizeChanger={totalData ? true : false}
          // showSizeChanger
          onShowSizeChange={onShowSizeChange}
          pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
        />
      </div>
      <UpdateRequest
        handleUpdateRequest={handleUpdateRequest}
        openUpdateModal={openUpdateModal}
        openUpdateData={openUpdateData}
        getList={getList}
      />

      <CancelRequest
        title={openCancelData?.request_id}
        close={handleCancelRequestClose}
        open={openCancelModal}
        deleteValues={openCancelData}
        name={"Request ID"}
        getList={getList}
      />

      <ReturnRequest
        handleReturnRequest={handleReturnRequest}
        openReturnModal={openReturnModal}
        openReturnData={openReturnData}
      />

      <UpdateEmailModal
        visible={openUpdateEmailModal}
        updateEmailData={updateEmailData}
        getList={getList}
        close={closeUpdateEmail}
      />
      {vewReport && (
        <ViewReport
          visible={vewReport}
          close={closeViewDrawer}
          reportData={reportData}
        />
      )}
    </>
  );
};
export default ListTable;
